<template lang="pug">
  v-form.recover-password.mt-3(
    ref="formRecoverPassword"
    @submit.prevent="onSubmit()"
  )
    v-container
      v-layout(
        row
        wrap
      )
        v-flex(xs12)
          alert-message(:error.sync="error")
        v-flex.py-0(
          xs12
        )
          h1 {{ $t('app.login.recoverPasswordComponent.title') }}
        v-flex.py-2(
          xs12
        )
          span.subtitle {{ $t('app.login.recoverPasswordComponent.subtitle') }}
        v-flex.py-0(
          xs12
        )
          input-email(
            required
            v-model="payload.email"
            :maxlength="40"
          )
        v-flex.py-0(
          xs8
          mx-auto
        )
          btn-primary(
            block
            :disabled="enableSubmit"
            :text="$t('app.login.recoverPasswordComponent.recover')"
            type="submit"
            :loading="loading"
          )
</template>

<script>
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import InputEmail from 'Support/components/inputs/InputEmail.vue';
import AlertMessage from 'Support/components/alerts/AlertMessage.vue';
import Recover from 'Domain/recoverPassword/recover';

export default {
  name: 'RecoverPassword',
  components: {
    BtnPrimary,
    InputEmail,
    AlertMessage,
  },
  data() {
    return {
      payload: {
        email: '',
      },
      error: {},
      loading: false,
    };
  },
  computed: {
    enableSubmit() {
      return !this.payload.email;
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      const { email } = this.payload;
      const query = { email };
      Recover
        .recover({ email })
        .then(() => {
          this.$router.push({ name: 'PasswordRecoveryEmailSent', query });
        })
        .catch(({ response }) => {
          this.error = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
  .recover-password
    h1
      font-style normal
      font-weight bold
      font-size 36px
      line-height 39px
      color #113752
    .subtitle
      font-style normal
      font-weight normal
      margin-top 24px
      font-size 14px
      color #113752
</style>
